
import gsap from "gsap";
// import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'dat.gui'
import {RGBELoader} from 'three/examples/jsm/loaders/RGBELoader.js'
import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js'
import {DRACOLoader} from 'three/examples/jsm/loaders/DRACOLoader.js'
import {Setting} from './setting'
import {Camera} from './camera'
import {Renderer} from './renderer'
import {CreateLight} from './createLight'
import {ArrangeHouse} from './arrangeHouse'
import { AnimationMixer, Scene, HemisphereLight,
	CubeUVReflectionMapping, CubeTextureLoader, Clock, Group } from 'three';

let modelPath = (location.hostname === "localhost") ? '/assets/glb/' : '/sites/all/themes/oceanpark/glb/';

export function InitThreeJS ()
{
	//IMPORT Setting
	const setting:any = new Setting();
	
	// Debug
	const gui = null;
	// const gui = new dat.GUI()
	
	// Canvas
	const canvas:any = setting.canvas;
	
	//ALLOW MOVE
	setting.allowMove = true;

	// Scene
	const scene = new Scene();

	// Lights
	const light = new HemisphereLight( 0xffffff, 0x444444 );
	light.position.set( 0, 300, 0 );
	scene.add( light );

	// Instantiate a loader
	const loader = new GLTFLoader();
	const dracoLoader = new DRACOLoader();
	// dracoLoader.setDecoderPath( 'three/examples/jsm/libs/draco/' );
	dracoLoader.setDecoderPath('https://www.gstatic.com/draco/v1/decoders/');
	loader.setDRACOLoader( dracoLoader );

	//MINI MAP INTERACTIVE
	setting.totalHaunt = 6;
	document.querySelectorAll('.hallow-2024-miniMapPin').forEach((v:any,i:any)=>{
		v.addEventListener("click", (e:any)=>{
			// console.log(e.currentTarget.dataset.pin);
			const index = Number(e.currentTarget.dataset.pin.replace('house',''))-1;
			// console.log(index);
			const y:any = window.scrollY
			+ document.querySelector('.halloween-2025-map-anchor').getBoundingClientRect().top
			+ document.querySelector('.halloween-2025-map').getBoundingClientRect().height*index/6;
			window.scrollTo({
				top: y,
				behavior: "smooth",
			});
		});
	})
	document.querySelector('.hallow-2024-miniMap-prev').addEventListener("click", ()=>{
		if(setting.currentHaunt>0){
			setting.allowMove = false;
			setting.currentHaunt--;
			const y:any = window.scrollY
			+ document.querySelector('.halloween-2025-map-anchor').getBoundingClientRect().top
			+ document.querySelector('.halloween-2025-map').getBoundingClientRect().height*setting.currentHaunt/7;
			window.scrollTo({
				top: y,
				behavior: "smooth",
			});
			ArrangeHouse(setting, true);
			setTimeout(()=>{
				setting.allowMove = true;
			},1000)
		}
	});
	document.querySelector('.hallow-2024-miniMap-next').addEventListener("click", ()=>{
		if(setting.currentHaunt<(setting.totalHaunt-1)){
			setting.allowMove = false;
			setting.currentHaunt++;
			const y:any = window.scrollY
			+ document.querySelector('.halloween-2025-map-anchor').getBoundingClientRect().top
			+ document.querySelector('.halloween-2025-map').getBoundingClientRect().height*setting.currentHaunt/7;
			window.scrollTo({
				top: y,
				behavior: "smooth",
			});
			ArrangeHouse(setting, true);
			setTimeout(()=>{
				setting.allowMove = true;
			},1000)
		}
	});
	var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

	//LOAD ENVIRONMENT
	// new RGBELoader()
	// .setPath( '/assets/glb/' )
	// .load( 'environment.hdr', function ( texture ) {
		// texture.mapping = CubeUVReflectionMapping ;
		// scene.environment = texture;
		// Load a glTF resource
		loader.load(
			// resource URL
			modelPath+'house.glb',
			// called when the resource is loaded
			async function ( gltf ) {
				setting.glb = gltf.scene;
				var group = new Group();
				group.add( setting.glb );
				scene.add( group );

				if(!isMobile){
					document.addEventListener("mousemove", (event:any) => {
						const centerX:any = window.innerWidth/2;
						const centerY:any = window.innerHeight/2;

						const x:any = event.clientX-centerX;
						const y:any = event.clientY-centerY;

						// group.rotation.x = -(y/centerY)*.05;
						// group.rotation.y = -(x/centerX)*.05;
						let rotationX = -(y/centerY)*.05;
						let rotationY = -(x/centerX)*.05;

						gsap.to(group.rotation, { 
							duration: .6, 
							ease: "power2.out",
							x: rotationX,
							y: rotationY
						});
					});
				}
				
				// glb.rotation.x = Math.PI/4;
				setting.glb.position.y = -.5;

				// setting.glb.scale.set(.011,.011,.011);
				setting.glb.scale.set(.05,.05,.05);
	
				// const loader = new CubeTextureLoader();
				// loader.setPath('/img/three/');
				// setting.glb.traverse(function (node:any) {
					// if a node has a material attribute - it can have a envMap
					// node.receiveShadow = true;
					// node.castShadow = true;
					// if (node.material) {
						// node.material.envMap = cubeTexture;
						// node.material.envMap = texture;
						// node.material.envMapIntensity = .5;
						// node.material.needsUpdate = true;
				// 	}
				// })
	
				// const glbFolder = gui.addFolder(`glb`);
				// glbFolder.add(setting.glb .position, 'x', -3, 3);
				// glbFolder.add(setting.glb .position, 'y', -3, 3);
				// glbFolder.add(setting.glb .position, 'z', -3, 3);
				// glbFolder.add(setting.glb .rotation, 'x', -10, 10);
				// glbFolder.add(setting.glb .rotation, 'y', -10, 10);
				// glbFolder.add(setting.glb .rotation, 'z', -10, 10);
				// glbFolder.open();

				CreateLight(0xffffff, {x:10, y:10, z:0},.1,false,scene, gui)
				// CreateLight(0xffffff, {x:-20, y:20, z:-15},.5,false,scene, gui)
				CreateLight(0xffffff, {x:20, y:50, z:50},3,false,scene, gui)
				// CreateLight(0xffffff, {x:50, y:20, z:20},0,false,scene, gui)
	

				ArrangeHouse(setting);
				window.addEventListener('scroll', (v) =>
				{
					if(setting.allowMove){
						ArrangeHouse(setting);
					}
				})
			},
			// called while loading is progressing
			function ( xhr ) {
				document.querySelector('.halloween-2025-map-map3d-loader')?.classList.add('finished');
				// document.querySelector('.webgl')?.classList.add('finished');
				// console.log( ( xhr.loaded / xhr.total * 100 ) + '% loaded' );
			},
			// called when loading has errors
			function ( error ) {
				// console.log( 'An error happened' );
			}
		);
	// });

	const updateRenderer:any = ()=> {
		// Update sizes
		setting.sizes.width = document.body.clientWidth
		setting.sizes.height = window.innerHeight

		// Update camera
		camera.aspect = setting.sizes.width / setting.sizes.height
		camera.updateProjectionMatrix()

		// Update renderer
		renderer.setSize(setting.sizes.width, setting.sizes.height)
		
		if (isMobile) {
			renderer.setPixelRatio(Math.min(window.devicePixelRatio, .8))
		}else{
			renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1))
		}
	}

	// Camera
	const camera:any = Camera(setting.sizes, scene, gui);
	setting.camera = camera;

	//Renderer
	const renderer:any = Renderer(canvas, setting.sizes);

	let lastWidth = 0;
	window.addEventListener('resize', () =>
	{
		if(window.innerWidth!=lastWidth){
			lastWidth = window.innerWidth;
			updateRenderer();
		}
	})
	updateRenderer();

	//ANIMATE
	const clock = new Clock()
	const tick = () =>
	{
			// Render
			renderer.render(scene, camera)
			// effectComposer.render();

			// Call tick again on the next frame
			window.requestAnimationFrame(tick)
	}

	tick();
}